import { render, staticRenderFns } from "./FileDropzone.vue?vue&type=template&id=72f708ce&scoped=true&"
import script from "./FileDropzone.vue?vue&type=script&lang=js&"
export * from "./FileDropzone.vue?vue&type=script&lang=js&"
import style0 from "./FileDropzone.vue?vue&type=style&index=0&id=72f708ce&prod&scoped=true&lang=css&"
import style1 from "./FileDropzone.vue?vue&type=style&index=1&id=72f708ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f708ce",
  null
  
)

export default component.exports